import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';

interface CancelButtonProps {
    onClick?: () => void;
    iconOnly?: boolean;
    disabled?: boolean;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onClick, iconOnly = false, disabled = false }) => (
    <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={`st-btn st-btn--outline${iconOnly ? ' st-btn--icon' : ''}`}
    >
        <FontAwesomeIcon icon={faBan} />
        {!iconOnly && <span>Zrušiť</span>}
    </button>
);

export default CancelButton;
